import { useState } from "react";
import DashboardContent from "./DashboardContent";
import Sidebar from "./Sidebar";
import { useEffect } from "react";
import { useCallback } from "react";
import LandingPage from "./LandingPage";

const API_URL = process.env.REACT_APP_API_URL; // Ensure this matches your backend URL

export default function Dashboard() {
  const [activeSection, setActiveSection] = useState("Home");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const credentials = `${username}:${password}`;
  const encodedCredentials = btoa(credentials); // Base64 encode the credentials

  const [customers, setCustomers] = useState([]);
  const [applicators, setApplicators] = useState([]);
  const [designs, setDesigns] = useState([]);
  const [coupons, setCoupons] = useState([]);

  const handleFetchCustomers = useCallback(async () => {
    try {
      const token = localStorage.getItem("x-auth-token");
      // console.log(token);
      const response = await fetch(`${API_URL}/api/overview/users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        setCustomers(responseData.data.summary.customers || []);
      } else {
        console.error("Failed to fetch projects:", responseData.message);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  }, [encodedCredentials]);

  const handleFetchApplicators = useCallback(async () => {
    try {
      const token = localStorage.getItem("x-auth-token");
      // console.log(token);
      const response = await fetch(`${API_URL}/api/overview/users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        setApplicators(responseData.data.summary.applicators || []);
        // console.log("Projects fetched:", responseData);
      } else {
        console.error("Failed to fetch projects:", responseData.message);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  }, [encodedCredentials]);

  const handleFetchDesigns = useCallback(async () => {
    try {
      const token = localStorage.getItem("x-auth-token");
      // console.log(token);
      const response = await fetch(`${API_URL}/api/overview/designs`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        setDesigns(responseData.data.summary.designs || []);
        // console.log("Projects fetched:", responseData);
      } else {
        console.error("Failed to fetch projects:", responseData.message);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  }, [encodedCredentials]);

  const handleFetchCoupons = useCallback(async () => {
    try {
      const token = localStorage.getItem("x-auth-token");
      // console.log(token);
      const response = await fetch(`${API_URL}/api/coupon`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        setCoupons(responseData.data?.summary.coupons);
      } else {
        throw new Error(
          responseData.data?.message || "Failed to fetch coupons.",
        );
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  }, [encodedCredentials]);

  // useEffect that runs only when activeSection changes
  useEffect(() => {
    if (activeSection === "Customers") {
      handleFetchCustomers();
    } else if (activeSection === "Applicators") {
      handleFetchApplicators();
    } else if (
      activeSection === "All Designs" ||
      activeSection === "All Requests"
    ) {
      handleFetchDesigns();
    } else if (activeSection === "All Coupons") {
      handleFetchCoupons();
    }
  }, [
    activeSection,
    handleFetchCustomers,
    handleFetchApplicators,
    handleFetchDesigns,
    handleFetchCoupons,
  ]); // Fetch data

  // console.log(userId)

  return (
    <div className="tw-flex tw-flex-col md:tw-flex-row tw-h-screen tw-gap-4">
      {/* Mobile Toggle Button  */}
      <button
        className="tw-m-4 tw-p-2 tw-bg-[#00B5ED] tw-text-white tw-rounded-md md:tw-hidden"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        ☰ Menu
      </button>

      <Sidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      {activeSection === "Home" ? (
        <LandingPage setActiveSection={setActiveSection} />
      ) : (
        <DashboardContent
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          customers={customers}
          applicators={applicators}
          designs={designs}
          coupons={coupons}
          setCoupons={setCoupons}
          setDesigns={setDesigns}
          setApplicators={setApplicators}
          setCustomers={setCustomers}
          handleFetchApplicators={handleFetchApplicators}
          handleFetchCustomers={handleFetchCustomers}
        />
      )}
    </div>
  );
}
